import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { AuthProvider } from "./config/AuthProvider.js";

import Principal from "./pages/public/Principal.jsx";
import Conferencias from "./pages/public/Conferencias.jsx";
import Contacto from "./pages/public/Contacto.jsx";
import Galeria from "./pages/public/Galeria.jsx";
import Devocionario from "./pages/public/Devocionario.jsx";
import ResolucionLibros from "./pages/public/ResolucionLibros.jsx";
import VisorLibro from "./pages/public/VisorLibro.jsx";
import LogIn from "./components/login/LogIn.jsx";

import PrincipalAdmin from "./pages/admins/Principal.jsx";
import VideoManager from "./pages/admins/VideoManager.jsx";
import Configuracion from "./pages/admins/Configuracion.jsx";
import GaleriaAdmin from "./pages/admins/Galeria.jsx";
import BannerAdmin from "./pages/admins/BannerAdmin.jsx";
import LibrosAdmin from "./pages/admins/LibrosAdmin.jsx";
import ResolucionLibrosAdmin from "./pages/admins/ResolucionLibrosAdmin.jsx";
import ConcactoInfo from "./pages/admins/ContactoInfo.jsx";
import DevocionarioInfo from "./pages/admins/Devocionario.jsx";
import MensajeAdmin from "./pages/admins/MensajeAdmin.jsx";
import NoticiasAdmin from "./pages/admins/NoticiasAdmin.jsx";

import PrincipalUser from "./pages/user/Principal.jsx";
import Compras from "./pages/user/Compras.jsx";
import ConfiguracionUser from "./pages/user/Configuracion.jsx";

import VisitCounter from "./pages/public/VisitCounter.jsx";
import NewsTicker from "./components/news/NewsTicker.jsx";

import NotFound from "./pages/error/notFound.jsx";

const App = () => {
  return (
    <>
      <AuthProvider>
        <NewsTicker />
        <Router>
          <Routes>
            <Route path="/admin" element={<PrincipalAdmin />} />
            <Route path="/admin/conferencias" element={<VideoManager />} />
            <Route path="/admin/configuracion" element={<Configuracion />} />
            <Route path="/admin/galeria" element={<GaleriaAdmin />} />
            <Route path="/admin/banner" element={<BannerAdmin />} />
            <Route path="/admin/libros" element={<LibrosAdmin />} />
            <Route
              path="/admin/resolucion-de-libros"
              element={<ResolucionLibrosAdmin />}
            />
            <Route path="/admin/contacto" element={<ConcactoInfo />} />
            <Route path="/admin/devocionario" element={<DevocionarioInfo />} />
            <Route path="/admin/mensaje" element={<MensajeAdmin />} />
            <Route path="/admin/noticias" element={<NoticiasAdmin />} />

            <Route path="/user/" element={<PrincipalUser />} />
            <Route path="/user/compras" element={<Compras />} />
            <Route path="/user/configuracion" element={<ConfiguracionUser />} />

            <Route path="/" element={<Principal />} />
            <Route path="/conferencias" element={<Conferencias />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/devocionario" element={<Devocionario />} />
            <Route
              path="/resolucion-de-libros"
              element={<ResolucionLibros />}
            />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/visor-libro" element={<VisorLibro />} />
            <Route path="/IniciarSesion" element={<LogIn />} />

            {/* Fallback para rutas no encontradas */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </AuthProvider>
      <VisitCounter />
    </>
  );
};

export default App;
